import { Text, Heading, Modal, CloseButton } from '@smarterservices/smarter-ui';
import { Button } from '@instructure/ui';
import useSessionStore from '../../stores/session';

const EndSessionModal = () => {
  const { setEndSessionSid, endSessionSid, endSession, getSessionData, } = useSessionStore();

  // get the session info for this session
  const sessions = useSessionStore((state) => state.sessions);

  if (!endSessionSid) {
    return null;
  }

  const session = getSessionData(endSessionSid);

  return (
    <Modal
      open={endSessionSid?.length}
      onDismiss={() => setEndSessionSid(null)}
      label="End Session"
    >
      <Modal.Header>
        <CloseButton
          placement="end"
          offset="small"
          onClick={() => setEndSessionSid(null)}
          screenReaderLabel="Close"
        />
        <Heading>End Session</Heading>
      </Modal.Header>
      <Modal.Body>
        <Text>Are you sure you want to end <b>{session?.firstName} {session?.lastName}'s</b> session?</Text>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => endSession()} color="primary">
          Yes, End Session
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EndSessionModal;
